var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.files),function(file){return _c('div',{key:file.id},[_c('ObjectFileItem',{attrs:{"file":file,"lang":_vm.lang,"vtitle":_vm.vtitle}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }